export class WidgetTableCell {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": "double"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WidgetTableCell.attributeTypeMap;
    }
    constructor() {
    }
}
